export const tableStyles = {
  style: { textAlign: 'center' },
  headerStyle: { textAlign: 'center', backgroundColor: '#02CC98', color: '#FFF' },
};
